export default "__VITE_ASSET__0uEsxvQ2__"